<template>
    <div>
        <tracker-new-data-header v-if="!editTarget" :columns="columns"></tracker-new-data-header>
        <div v-if="canTrackManually" class="row px-3 new-data-inputs">
            <div class="col-2 px-1 py-3">
                <v-date-picker
                    dusk="date"
                    placeholder="MM/DD/YYYY"
                    id="date"
                    class="picker-container"
                    popover-align="left"
                    v-model="date"
                ></v-date-picker>
            </div>
            <div class="col-3 px-1 py-3 mb-1">
                <div v-for="target in goal.parameters.targets" class="row no-gutters mb-1">
                    <span class="small mr-2 col-4">{{ target }}:</span>
                    <div class="col-4 d-flex justify-content-end">
                        <input
                            v-model.number="results[target]"
                            type="text"
                            class="d-inline form-control form-control-sm text-right"
                            style="max-width: 3rem; line-height: 0.5;"
                        />
                    </div>
                    <span class="small mr-2 col-2 text-right">{{
                        time && !isNaN(results[target])
                            ? Math.round((100 * results[target]) / (time / 60)) / 100 + "/min."
                            : "N/A"
                    }}</span>
                </div>
            </div>
            <div class="px-1 col-2 py-3">
                <time-input v-model="time"></time-input>
            </div>
            <div class="px-1 col-1 py-3">
                {{ goal.parameters.success }}
            </div>
            <div class="px-1 col-3 py-3">
                <input v-model="note" class="form-control form-control-sm" name="note" />
            </div>
            <tracker-new-data-actions
                :saving="saving"
                :edit-target="editTarget"
                @save-data="submitData()"
                @edit-done="$emit('edit-done')"
            ></tracker-new-data-actions>
        </div>
    </div>
</template>

<script>
import { trackerNewDataCommon } from "./trackerNewDataCommon";

export default {
    name: "TrackerNewDataMultiTally",
    mixins: [trackerNewDataCommon],
    data() {
        return {
            columns: {
                titles: [`Date`, `Count (Count/min.)`, `Time`, `Goal`, `Note`, ``],
                col: [2, 3, 2, 1, 3, 1],
            },
            date: new Date(),
            success: 0,
            results: {},
            note: "",
            duration: 0,
            time: 0,
        };
    },

    mounted() {
        if (this.editTarget) {
            this.populateEdit();
        }
    },

    beforeDestroy() {
        this.resetComponent();
    },

    methods: {
        populateEdit() {
            let editTarget = { ...this.editTarget };
            this.date = editTarget.session_at;
            this.note = editTarget.notes;
            this.results = editTarget.data.results;
            this.time = editTarget.data.time;
        },

        submitData() {
            const results = { ...this.results };
            if (
                !Object.keys(results).length ||
                Object.values(results).some(value => isNaN(value))
            ) {
                this.$swal("Error", `The values for "Count" must be numbers.`, "error");
                return;
            }
            const time = this.time;

            let payload = {
                data: {
                    type: "multi_tally",
                    time,
                    results,
                },
                notes: this.note,
                session_at: this.isoDate,
            };
            this.$emit("save-data", payload);
            this.resetComponent();
        },

        resetComponent() {
            this.date = new Date();
            this.success = 0;
            this.results = {};
            this.note = "";
            this.time = 0;
        },
    },
};
</script>

<style scoped></style>
